<template>
    <CCard>
        <CCardBody>
            <CContainer class="section" fluid>
                <CRow class="border-bottom mb-3">
                    <CCol md="10">
                        <h2 class="section__title my-4">
                            {{ $t("general_config") }}
                        </h2>
                    </CCol>
                </CRow>
                <CRow alignHorizontal="center">
                    <CCol md="12">
                        <CForm
                            ref="formViewField"
                            @submit="submitForm($event, 'viewField')"
                        >
                            <CInput
                                :isValid="
                                    checkIfFormValid({
                                        formName: 'viewField',
                                        fieldName: 'name',
                                    })
                                "
                                :value.sync="$v.forms.viewField.name.$model"
                                :label="$t('name')"
                                v-bind="defaultInputConfig"
                                :disabled="true"
                                :placeholder="
                                    $t('this_field_is_auto_generated')
                                "
                            />
                            <CInput
                                :isValid="
                                    checkIfFormValid({
                                        formName: 'viewField',
                                        fieldName: 'code',
                                    })
                                "
                                :value.sync="$v.forms.viewField.code.$model"
                                :label="$t('code')"
                                v-bind="defaultInputConfig"
                            />

                            <CSelect
                                :options="[
                                    { value: 'text', label: $t('text') },
                                    { value: 'number', label: $t('number') },
                                    { value: 'email', label: $t('email') },
                                    { value: 'options', label: $t('options') },
                                    { value: 'date', label: $t('date') },
                                    { value: 'url', label: $t('url') },
                                    { value: 'boolean', label: $t('boolean') },
                                    {
                                        value: 'timestamp',
                                        label: $t('timestamp'),
                                    },
                                ]"
                                :isValid="
                                    checkIfFormValid({
                                        formName: 'viewField',
                                        fieldName: 'type',
                                    })
                                "
                                :label="$t('type')"
                                :placeholder="$t('--_select_an_option_--')"
                                :value.sync="$v.forms.viewField.type.$model"
                                v-bind="defaultInputConfig"
                            />

                            <SelectAsync
                                :label="$t('tag') + ':'"
                                :placeholder="$t('--_select_an_option_--')"
                                optionsValue="uuid"
                                :optionsLabel="(item) => item.name"
                                endpoint="/tags"
                                :fetchConfig="{
                                    baseURL: ApiCore,
                                }"
                                :isValid="
                                    checkIfFormValid({
                                        formName: 'viewField',
                                        fieldName: 'tagUuid',
                                    })
                                "
                                :value.sync="$v.forms.viewField.tagUuid.$model"
                                v-bind="defaultInputConfig"
                            />

                            <div class="form-group form-row font-weight-bold">
                                <label
                                    class="col-form-label col-sm-2 col-form-label-sm"
                                    >{{ $t("is_custom") }}</label
                                >
                                <div class="col-sm-10">
                                    <CSwitch
                                        :checked.sync="
                                            $v.forms.viewField.isCustom.$model
                                        "
                                        :isValid="
                                            checkIfFormValid({
                                                formName: 'viewField',
                                                fieldName: 'isCustom',
                                            })
                                        "
                                        color="primary"
                                        shape="pill"
                                        variant="3d"
                                        name="integration_type"
                                        size="sm"
                                    />
                                </div>
                            </div>
                        </CForm>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
        <CCardFooter class="d-flex">
            <ButtonSave
                color="success"
                @click="executeSubmitForm('formViewField')"
                :disabled="forms.viewField._loading"
            />
            <ButtonBack class="mr-3" title="Go back" />
        </CCardFooter>
    </CCard>
</template>

<script>
/** Components */
import SelectAsync from "£lement/SelectAsync";
import ButtonBack from "£lement/ButtonBack";
import ButtonLoading from "~/components/ButtonLoading.vue";
import ButtonSave from "~/components/ButtonSave.vue";
/** Mixins */
import formMixin from "~/mixins/form";
import { validationMixin } from "vuelidate";

/** Others */
import { required } from "vuelidate/lib/validators";
import { cilPencil, cilCaretBottom, cilCaretTop, cilSave } from "@coreui/icons";

export default {
    name: "FieldGeneralTab",
    mixins: [formMixin, validationMixin],
    icons: {
        cilPencil,
        cilCaretBottom,
        cilCaretTop,
        cilSave,
    },

    components: {
        SelectAsync,
        ButtonBack,
        ButtonLoading,
        ButtonSave,
    },

    props: {
        field: {
            type: Object,
        },
        mode: {
            type: String,
            default: "create",
        },
        loading: Boolean,
    },

    data() {
        return {
            forms: {
                viewField: {
                    uuid: null,
                    name: null,
                    code: null,
                    type: null,
                    isCustom: true,
                    tagUuid: null,
                    // use: null,
                    // options: null,
                    _loading: false,
                    _matchResponse: "_items",
                },
            },
        };
    },
    watch: {
        "forms.viewField._loading": {
            handler: async function (newValue) {
                this.$emit("update:loading", newValue);
            },
            deep: true,
        },
    },
    validations: {
        forms: {
            viewField: {
                name: {
                    // required,
                },
                code: {
                    required,
                },
                type: {
                    required,
                },
                isCustom: {
                    required,
                },
                tagUuid: {
                    // required,
                },
                use: {
                    // required,
                },
            },
        },
    },
    methods: {
        async addField() {
            await this.sendForm({
                formName: "viewField",
                url: "/fields",
                fetch: {
                    baseURL: process.env.VUE_APP_API_CORE,
                },
            });
        },
        async updateField() {
            await this.sendForm({
                formName: "viewField",
                method: "PUT",
                url: "/fields/" + this.field.uuid,
                fetch: {
                    baseURL: process.env.VUE_APP_API_CORE,
                },
            });
        },
        async submitForm(e, formName) {
            e.preventDefault();
            if (this.mode === "edit") {
                await this.updateField();
            } else {
                await this.addField();
            }
        },
    },
    async mounted() {
        this.forms.viewField = this.field;
    },
};
</script>

<style>
</style>